import { AxiosInstance } from 'axios';

import { WishlistProduct } from '../../types/WishlistProduct';
import { wishlishEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { AddToWishListInput } from './WishlistApi.schema';

class WishlistApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getWishlishProducts = async (cartId: number): Promise<WishlistProduct[]> =>
    this.#requestInstance.get(wishlishEndpoints.wishlishProductId(cartId));

  addToWishlist = async (input: AddToWishListInput): Promise<WishlistProduct> =>
    this.#requestInstance.post(wishlishEndpoints.wishlishProduct, input);

  removeFromWishlist = async (wishlistProductId: number): Promise<void> =>
    this.#requestInstance.delete(wishlishEndpoints.wishlishProductId(wishlistProductId));
}

export const wishlistApi = new WishlistApi(axios);
